import { normalizeSellerReferralCode } from "@/lib/seller-referral/seller-code-cookie"

export type SellerReferralSignupSource = "url" | "local_storage" | "cookie"

export function resolveSellerReferralCodeAtSignup(input: {
  urlCode: string | null | undefined
  localStorageCode: string | null | undefined
  cookieCode: string | null | undefined
}): { code: string | null; source: SellerReferralSignupSource | null } {
  const url = normalizeSellerReferralCode(input.urlCode)
  if (url) return { code: url, source: "url" }

  const ls = normalizeSellerReferralCode(input.localStorageCode)
  if (ls) return { code: ls, source: "local_storage" }

  const cookie = normalizeSellerReferralCode(input.cookieCode)
  if (cookie) return { code: cookie, source: "cookie" }

  return { code: null, source: null }
}

export function resolveSellerReferralCapturedAtAtSignup(input: {
  hasUrlCode: boolean
  localStorageCapturedAt: string | null | undefined
  now?: Date
}): string | null {
  if (input.hasUrlCode) {
    return (input.now ?? new Date()).toISOString()
  }
  const raw = input.localStorageCapturedAt?.trim()
  return raw || null
}
